
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"#5C6970","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75.813h13.938v4.53H19.5V23.5H.75V.812z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M1.511 24c-.827 0-1.5-.673-1.5-1.5v-21c0-.827.673-1.5 1.5-1.5h12.025a6.483 6.483 0 016.475 6.473V12.5a.5.5 0 01-1 0V6.473c0-.153-.007-.312-.022-.473h-3.478c-.827 0-1.5-.673-1.5-1.5V1.022A5.127 5.127 0 0013.536 1H1.511a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h3.978a.5.5 0 010 1H1.511zm13.5-19.5a.5.5 0 00.5.5h3.297a5.491 5.491 0 00-3.797-3.797V4.5z"}}),_c('path',{attrs:{"d":"M9.489 23.999a.5.5 0 01-.5-.5v-7.5h-1.5a.5.5 0 010-1h4a.5.5 0 010 1h-1.5v7.5a.5.5 0 01-.5.5zm12 0a.5.5 0 01-.5-.5v-7.5h-1.5a.5.5 0 010-1h4a.5.5 0 010 1h-1.5v7.5a.5.5 0 01-.5.5zm-3.999 0a.498.498 0 01-.448-.276l-1.553-3.106-1.553 3.105a.496.496 0 01-.67.224.5.5 0 01-.225-.671l1.888-3.776-1.888-3.776a.5.5 0 01.895-.448l1.553 3.105 1.553-3.105a.498.498 0 01.671-.223.5.5 0 01.224.671l-1.888 3.776 1.888 3.776a.5.5 0 01-.448.724z"}})])
          )
        }
      }
    